// custom lightbox

window.askaronUI = window.askaronUI ?? {};
askaronUI.lightbox = {
  show: function(items, activeIndex = 0) {
    if (!items) {
      console.warn('No items for lightbox')
      return;
    }
    makeLightbox({
      galleryId: 'custom-lightbox-123',
      items: items,
      activeIndex: activeIndex
    });
  }
};


(function() {
  
  $(document).on('click', '[data-lightbox-dismiss]', function(event) {
    event.preventDefault();
    dismissLightbox();
  });

  $(document).on('click', '.lightbox-swiper-slide', function(event) {
    if ($(event.target).closest('.lightbox-swiper-slide-content').length > 0) {
      return;
    }
    event.preventDefault();
    dismissLightbox();
  });

  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      dismissLightbox();
    }
  });

  $(document).on('click', '[data-lightbox-gallery-item]', function(event) {
    event.preventDefault();
    let galleryId = $(this).data('lightbox-gallery-item');
    let $gallery = $(`[data-lightbox-gallery="${galleryId}"]`);
    let items = [];
  
    let onlyVisible = $gallery.data('lightbox-only-visible-items') || false;
    let selectors = onlyVisible ? '[data-lightbox-gallery-item]:visible' : '[data-lightbox-gallery-item]';
  
  
    $gallery.find(selectors).each(function() {
      let src = $(this).data('src') ?? $(this).attr('href');
      if (!src) {
        console.error('No src found for lightbox item');
        return;
      }
      items.push({
        src: src,
        type: $(this).data('lightbox-type') || 'image',
        ageRestricted: $(this).data('age-restricted') || false,
      });
    });
    let activeIndex = $gallery.find(selectors).index(this);
  
    makeLightbox({ galleryId, items, activeIndex });
  });

  $(document).on('click', '[data-lightbox-item]', function(event) {
    event.preventDefault();
    items = [];
    let src = $(this).data('src') ?? $(this).attr('href');
    if (!src) {
      console.error('No src found for lightbox item');
      return;
    }
    items.push({
      src: src,
      type: $(this).data('lightbox-type') || 'image',
      ageRestricted: $(this).data('age-restricted') || false,
    });
    makeLightbox({
      galleryId: 'none',
      items: items
    });
  });

  function dismissLightbox() {
    let $modal = $('.lightbox-swiper-modal');
    if ($modal.length) {
      $modal.remove();
      $('body').removeClass('lightbox-open');
    }
  }

  function makeLightbox({ galleryId, items, activeIndex = 0 }) {
    $('.lightbox-swiper-container').remove();
  
    $('body').append(`
      <div class="lightbox-swiper lightbox-swiper-modal" data-gallery-id="${galleryId}">
        <div class="lightbox-swiper-backdrop" data-lightbox-dismiss=""></div>
        <div class="lightbox-swiper-close" data-lightbox-dismiss=""></div>
        <div class="lightbox-swiper-container" data-gallery-id="${galleryId}">
          <div class="swiper">
            <div class="swiper-wrapper"></div>
            <div class="swiper-button-next lightbox-swiper-button-next"></div>
            <div class="swiper-button-prev lightbox-swiper-button-prev"></div>
          </div>
        </div>
      </div>
    `);
    $('body').addClass('lightbox-open');
  
    //let loop = (items.length > 1);
    let loop = false;
  
    let lightboxSwiper = new Swiper(`.lightbox-swiper-container .swiper`, {
      loop: loop,
      simulateTouch: false,
      navigation: {
        nextEl: '.lightbox-swiper-button-next',
        prevEl: '.lightbox-swiper-button-prev',
      },
      spaceBetween: 360,
      virtual: {
        slides: items,
        cache: true,
        renderSlide: function(slide, index) {
          return makeLightboxItem(slide);
        }
      },
      zoom: {
        maxRatio: 2,
      },
      initialSlide: activeIndex,
    });
    lightboxSwiper.on('zoomChange', function(swiper, scale) {
      $(swiper.slides[swiper.activeIndex]).find('.lightbox-swiper-zoomable-element').css({'transform': `scale(${scale})`});
    });
    lightboxSwiper.on('slideChange', function(swiper) {
      if (typeof VK !== 'undefined' && VK.VideoPlayer) {
        let vkIframes = $(swiper.slidesEl).find('iframe[src*="vk.com/video_ext"]');
        vkIframes.each(function() {
          const player = VK.VideoPlayer(this);
          player.pause();
        })
      }
    });
  }

  function makeLightboxItem(item) {
    let itemContent = '';
    let ageOverlay = '';
    console.log(item.ageRestricted);
    if (item.ageRestricted) {
      ageOverlay = `<div role="button" class="b-age-overlay lightbox-swiper-zoomable-element">
                      <div class="b-age-overlay__icon"></div>
                      <div class="b-age-overlay__text">Подтверждаю, что мне есть 18&nbsp;лет</div>
                    </div>`;
    }
    if (item.type === 'video') {
      lightBoxVideoSources.forEach((source, key) => {
        let match = item.src.match(source.regex);
        if (match) {
          let embedUrl = source.embedUrl(match);
          let addClass = '';
          if (item.src.includes('clip-')) {
            addClass += ' lightbox-swiper-slide-content_video-vertical';
          }
  
          itemContent += `
                <div class="swiper-slide lightbox-swiper-slide">
                  <div class="lightbox-swiper-slide-content lightbox-swiper-slide-content_video ${addClass}">
                    ${ageOverlay}
                    <iframe loading="lazy" width="1280" height="720" src="${embedUrl}" frameborder="0" allow="clipboard-write; autoplay" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
                  </div>
                </div>
              `;
  
          //vk video widjet player
          if (key === "vk" && $('script[src*="vk.com/js/api/videoplayer.js"]').length === 0) {
            $('body').append('<script src="https://vk.com/js/api/videoplayer.js"></script>');
          }
  
        }
      });
    } else {
      itemContent += `
        <div class="swiper-slide lightbox-swiper-slide">
          <div class="swiper-zoom-container lightbox-swiper-slide-content">
            ${ageOverlay}
            <img class="lightbox-swiper-img" src="${item.src}" loading="lazy" alt="">
          </div>
        </div>
      `;
    }
    if (itemContent === '') {
      itemContent += `
        <div class="swiper-slide lightbox-swiper-slide">
          <div class="lightbox-swiper-slide-content lightbox-swiper-slide-content_video">
            Загрузка...
          </div>
        </div>
      `;
    }
    return itemContent;
  }

  const lightBoxVideoSources = new Map([
    ["vk", 
      {
        //regex: /^(?:https?:\/\/)?(?:m\.)?((vkvideo\.ru)|(vk\.(com|ru))).*(photo|video|audio|doc|page|note|poll|album|market|market_album|audio_playlist)(-?\d+)_(\d+)(.*)\/?$/,
        regex: /^(?:https?:\/\/)?(?:m\.)?((vkvideo\.ru)|(vk\.(com|ru))).*(photo|video|audio|doc|page|note|poll|album|market|market_album|audio_playlist|clip)(-?\d+)_(\d+)|.*[?&]z=(photo|video|audio|doc|page|note|poll|album|market|market_album|audio_playlist|clip)(-?\d+)_(\d+).*$/,
        embedUrl: (match) => {
          const videoId = match[6] + '&id=' + match[7];
          //return `https://vk.com/video_ext.php?oid=${videoId}&hd=2&autoplay=1`;
        return `https://vk.com/video_ext.php?oid=${videoId}&hd=2&js_api=1`;
        },
      }
    ],
    ["rutube", 
      {
        regex: /rutube\.ru\/video\/([a-zA-Z0-9]+)/,
        embedUrl: (match) => {
          const videoId = match[1];
          return `https://rutube.ru/play/embed/${videoId}?autoplay=true`;
        }
      }
    ],
    ["youtube", 
      {
        regex: /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:(?:watch)?\?(?:.*&)?v(?:i)?=|(?:embed|v|vi|user|shorts)\/))([^\?&\"'>]+)/,
        embedUrl: (match) => {
          const videoId = match[1];
          return `https://www.youtube.com/embed/${videoId}`;
        }
      }
    ],
  ]);

})();